export const billingEventsFiscalDocumentsDefaultColumns = [
  { label: '', value: 'id', hidden: true },
  { label: 'Status', value: 'status' },
  { label: 'Transação', value: 'protocol_number' },
  { label: 'Tipo', value: 'type' },
  { label: 'Detalhes', value: 'details' },
  { label: 'Valor total', value: 'total_amount' },
  { label: 'Data e hora', value: 'created_at' },
  { label: 'Estabelecimento', value: 'establishment_company_branch' },
  { label: 'Filial da empresa', value: 'client_company_branch' },
  { label: 'Ações', value: 'action', className: 'w-9' },
];
